export const Products = {
	Sport: 1,
	Fixed: 2,
	NSW: 3,
	SUP: 4,
	TATTS: 5,
	Mid: 6,
	Top: 7,
	BO4: 8,
	SP: 9,
	TF: 10,
	BOB: 11
};

export const ProductRank = [
	{ id: Products.Fixed, rank: 1 },
	{ id: Products.BO4, rank: 2 },
	{ id: Products.SP, rank: 3 },
	{ id: Products.Top, rank: 4 },
	{ id: Products.Mid, rank: 5 }
];

export const ProductNames = {
	[Products.Sport]: 'Sport',
	[Products.Fixed]: 'Fixed',
	[Products.NSW]: 'NSW',
	[Products.SUP]: 'VIC',
	[Products.TATTS]: 'TATTS',
	[Products.Mid]: 'Mid',
	[Products.Top]: 'Top',
	[Products.BO4]: 'BO4',
	[Products.SP]: 'SP',
	[Products.TF]: 'TF',
	[Products.BOB]: 'BOB'
};
